import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "typeOfTime"
})
export class TypeOfTimePipe implements PipeTransform {

  constructor(private translationService: TranslateService) {
  }

  transform(value: number): string {
    if (value === 0) {
      // Returning empty because 0 is the default value for enums in AL
      return " ";
    }


    const name = TypeOfTime[value];

    if (!name) {
      return this.translationService.instant("STATUS.UNDEFINED");
    }

    return this.translationService.instant(`TypeOfTimePipe.STATUS.${name}`);
  }
}

enum TypeOfTime {
  Requested = 1,
  Booked = 2,
  Actual = 3,
  ETA = 4,
  Initial = 5,
  Closing = 6
}
